import * as XLSX from 'xlsx';

const ENTRANCE_MAP = { 0: '优培人才', 1: '技术人才', 2: '操作人才' };
const GENDER_MAP = { 0: '女', 1: '男', 2: '其他' };
const POLITICAL_MAP = {
    1: '中共党员', 2: '中共预备党员', 3: '共青团员', 4: '民革成员', 5: '民盟成员',
    6: '民建成员', 7: '民进成员', 8: '农工党成员', 9: '致公党成员', 10: '九三学社社员',
    11: '台盟成员', 12: '无党派人士', 13: '群众',
};
const APPROVAL_STATUS_MAP = {
    0: '待签名', 1: '待补充资料', 2: '待审批', 3: '审批通过', 4: '审批不通过',
};
const FILL_METHOD_MAP = { 0: '网页端', 1: '煤婆新消息', 2: '微信小程序', 3: '其他' };
const RELATION_MAP = { 0: '父亲', 1: '母亲', 2: '配偶', 3: '子女', 4: '兄弟', 5: '姐妹', 6: '其他' };
const WORK_TYPE_MAP = { 0: '煤矿井下一线', 1: '化工生产一线' };

const EDU_SEGMENTS = [
    { key: '专科', matchers: ['专科'] },
    { key: '本科', matchers: ['本科'] },
    { key: '研究生', matchers: ['研究生', '硕士'] },
    { key: '博士', matchers: ['博士'] },
];

function pick(obj, ...keys) {
    if (!obj) return '';
    for (let i = 0; i < keys.length; i++) {
        const val = obj[keys[i]];
        if (val !== null && val !== undefined && String(val).trim() !== '') {
            return val;
        }
    }
    return '';
}

function formatDateTime(val) {
    if (!val) return '';
    return String(val).replace('T', ' ').substring(0, 19);
}

function formatGraduationYear(val) {
    if (!val) return '';
    const str = String(val).trim();
    if (/^\d{4}$/.test(str)) return str;
    const match = str.match(/^(\d{4})/);
    return match ? match[1] : str.substring(0, 10);
}

function formatExportFileTime() {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
}

function formatNativePlace(item) {
    const parts = [
        pick(item, 'resident_province_city', 'residentProvinceCity'),
        pick(item, 'resident_city', 'residentCity'),
    ].filter((v) => String(v).trim() !== '');
    if (parts.length) {
        return parts.join(' ');
    }
    return pick(item, 'native_place', 'nativePlace');
}

function formatResidentAddress(item) {
    const address = pick(item, 'address');
    if (String(address).trim() !== '') {
        return address;
    }
    const native = pick(item, 'native_place', 'nativePlace');
    const hasRegion = pick(item, 'resident_province_city', 'residentProvinceCity')
        || pick(item, 'resident_city', 'residentCity');
    if (String(native).trim() !== '' && String(hasRegion).trim() === '') {
        return native;
    }
    return '';
}

function formatFamily(family) {
    if (!Array.isArray(family) || !family.length) {
        return '';
    }
    return family.map((f) => {
        const rel = RELATION_MAP[f.relationType != null ? f.relationType : f.relation_type] || '';
        const name = pick(f, 'name');
        const mobile = pick(f, 'mobile');
        const workUnit = pick(f, 'workUnit', 'work_unit');
        const position = pick(f, 'position');
        return [rel, name, mobile, workUnit, position].filter((v) => String(v).trim() !== '').join(' ');
    }).join('；');
}

function formatUserComments(comments) {
    if (!Array.isArray(comments) || !comments.length) {
        return '';
    }
    return comments.map((c) => pick(c, 'commentContent', 'comment_content')).filter(Boolean).join('；');
}

function normalizeEducationList(item) {
    const raw = item.educationHistory || item.education_history || [];
    return Array.isArray(raw) ? raw : [];
}

function matchEducationSegment(edu, matchers) {
    const label = String(pick(edu, 'segmentLabel', 'segment_label')).trim();
    return matchers.some((m) => label.indexOf(m) !== -1);
}

function findEducationSegment(item, matchers) {
    const list = normalizeEducationList(item);
    return list.find((edu) => matchEducationSegment(edu, matchers)) || null;
}

function formatDomesticText(edu) {
    const raw = edu.isDomestic != null ? edu.isDomestic : edu.is_domestic;
    if (raw === 1 || raw === '1') return '是';
    if (raw === 0 || raw === '0') return '否';
    return '';
}

function formatInstitutionValue(edu) {
    const isDomestic = edu.isDomestic != null ? edu.isDomestic : edu.is_domestic;
    if (isDomestic === 0 || isDomestic === '0') {
        const qs = edu.qsRanking != null ? edu.qsRanking : edu.qs_ranking;
        return qs != null && qs !== '' ? String(qs) : '';
    }
    return pick(edu, 'institutionType', 'institution_type');
}

function buildEducationColumns(item) {
    const cols = {};
    EDU_SEGMENTS.forEach(({ key, matchers }) => {
        const edu = findEducationSegment(item, matchers);
        const prefix = key;
        cols[`${prefix}-学校`] = edu ? pick(edu, 'graduatedInstitution', 'graduated_institution') : '';
        cols[`${prefix}-专业`] = edu ? pick(edu, 'major') : '';
        cols[`${prefix}-专业代码`] = edu ? pick(edu, 'majorCode', 'major_code') : '';
        cols[`${prefix}-学历`] = edu ? pick(edu, 'educationLevel', 'education_level') : '';
        cols[`${prefix}-毕业日期`] = edu ? formatGraduationYear(pick(edu, 'departureDate', 'departure_date')) : '';
        cols[`${prefix}-国内院校`] = edu ? formatDomesticText(edu) : '';
        cols[`${prefix}-院校层级或QS排名`] = edu ? formatInstitutionValue(edu) : '';
    });
    return cols;
}

function resolveEntranceLabel(item) {
    const name = pick(item, 'entrance_name', 'entranceName');
    if (name) return name;
    const type = item.entrance_type != null ? item.entrance_type : item.entranceType;
    return ENTRANCE_MAP[type] != null ? ENTRANCE_MAP[type] : (type !== '' && type != null ? String(type) : '');
}

function resolveMajorCategory(item) {
    const recruit = item.recruitPosition || item.recruit_position || {};
    const appCategory = pick(item, 'major_category', 'majorCategory');
    if (appCategory) return appCategory;
    return pick(recruit, 'majorCategory', 'major_category');
}

function resolveMajorName(item) {
    const recruit = item.recruitPosition || item.recruit_position || {};
    const entrance = item.entrance_type != null ? item.entrance_type : item.entranceType;
    if (Number(entrance) === 1) {
        const undergrad = pick(recruit, 'undergraduateMajorName', 'undergraduate_major_name');
        if (undergrad) return undergrad;
    }
    const recruitMajor = pick(recruit, 'majorName', 'major_name');
    if (recruitMajor) return recruitMajor;
    return pick(item, 'positionsName', 'positions_name');
}

function resolveReviewedLabel(status) {
    const s = Number(status);
    return s === 3 || s === 4 ? '是' : '否';
}

function buildExportRow(item) {
    const approvalStatus = item.approval_status != null ? item.approval_status : item.approvalStatus;
    const recruit = item.recruitPosition || item.recruit_position || {};
    const workType = item.work_type != null ? item.work_type : item.workType;
    return {
        报考入口: resolveEntranceLabel(item),
        专业类别: resolveMajorCategory(item),
        专业名称: resolveMajorName(item),
        应聘专业: pick(item, 'positionsName', 'positions_name'),
        工作类别: WORK_TYPE_MAP[workType] || '',
        是否已审核: resolveReviewedLabel(approvalStatus),
        审核状态: APPROVAL_STATUS_MAP[approvalStatus] || '',
        审批意见: pick(item, 'approval_comment', 'approvalComment'),
        人员批注: formatUserComments(item.userComments || item.user_comments),
        姓名: pick(item, 'name'),
        性别: GENDER_MAP[item.gender] || '',
        手机号: pick(item, 'phone'),
        政治面貌: POLITICAL_MAP[item.political_status != null ? item.political_status : item.politicalStatus] || '',
        身份证号: pick(item, 'id_card_number', 'idCardNumber'),
        籍贯: formatNativePlace(item),
        常住地址: formatResidentAddress(item),
        最高学历: pick(item, 'highest_education', 'highestEducation', 'education'),
        邮箱: pick(item, 'email'),
        填报时间: formatDateTime(pick(item, 'created_at', 'createdAt')),
        填写方式: FILL_METHOD_MAP[item.fill_method != null ? item.fill_method : item.fillMethod] || '',
        家庭成员: formatFamily(item.family || item.familyMemberList),
        招聘岗位学历要求: pick(recruit, 'educationRequire', 'education_require'),
        毕业年限要求: pick(recruit, 'graduationYearsRequirement', 'graduation_years_requirement'),
        ...buildEducationColumns(item),
    };
}

export function buildYearExportSheetRows(list) {
    return (Array.isArray(list) ? list : []).map((item) => buildExportRow(item));
}

export function parseContentDispositionFileName(contentDisposition, fallback) {
    if (!contentDisposition) {
        return fallback;
    }
    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match && utf8Match[1]) {
        try {
            return decodeURIComponent(utf8Match[1]);
        } catch (e) {
            return fallback;
        }
    }
    const plainMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    return plainMatch && plainMatch[1] ? plainMatch[1] : fallback;
}

export function parseJsonBlobError(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            try {
                resolve(JSON.parse(reader.result));
            } catch (e) {
                reject(e);
            }
        };
        reader.onerror = reject;
        reader.readAsText(blob);
    });
}

export function downloadYearApplicantsExcelBlob(blob, fileName) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || '考生信息.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    return link.download;
}

export function downloadYearApplicantsExcel(year, list) {
    const rows = buildYearExportSheetRows(list);
    const ws = XLSX.utils.json_to_sheet(rows.length ? rows : [{}]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, '考生信息');
    const fileName = `${year}考生信息-${formatExportFileTime()}.xlsx`;
    XLSX.writeFile(wb, fileName);
    return fileName;
}
